<div
	class="fixed inset-0 w-screen h-screen bg-black cursor-pointer"
	[ngClass]="{
		'z-50 opacity-40': showOverlay(),
		'-z-50 opacity-0': !showOverlay(),
	}"
></div>
